<template>
  <a
    :href="href"
    class="link"
    :class="{
      'icon-left': icon && iconLeft,
      'icon-right': icon && !iconLeft,
    }"
    v-bind="$attrs"
  >
    <Icon v-if="icon && iconLeft" class="icon" :name="icon" :size="iconSize" />
    <span>
      <slot />
    </span>
    <Icon v-if="icon && !iconLeft" class="icon" :name="icon" :size="iconSize" />
  </a>
</template>

<script setup lang="ts">
import Icon from '@/components/common/SvgIcon.vue'

defineProps({
  href: { type: String, default: '#' },
  color: { type: String, default: '' },
  icon: { type: String, default: 'arrow-top-right' },
  iconSize: { type: Number, default: 20 },
  iconLeft: { type: Boolean, default: false },
})
</script>

<style scoped lang="postcss">
.link {
  /* colors should be inherited from global styles for <a> tag */
  @apply inline-flex items-baseline;
}

.icon {
  @apply self-center;
}

.icon-left .icon {
  margin-right: 3px;
}

.icon-right .icon {
  margin-left: 3px;
}
</style>
